import { EventObject } from '@xstate/store-react';
import posthog from 'posthog-js';
import { StoreContext } from '../../../models/store/context';
import { StoreEvent } from '../../../enums/storeEvent';
import { AppStatus } from '../../../enums/appStatus';
import { log } from '@domgen/shared/utils/log';

/**
 * Restores store context from a previously saved session snapshot.
 *
 * Registers restored session id with PostHog and marks app state as ready when
 * event payload is present.
 *
 * @param _context Current store context, unused for restore logic.
 * @param event Event optionally containing persisted store context.
 * @returns Restored context when provided; otherwise no state change.
 */
export const restoreSession = <T extends EventObject = EventObject>(
  _context: StoreContext,
  event: T & { data?: StoreContext },
): StoreContext | void => {
  if (event.data) {
    log.debug({ message: StoreEvent.RESTORE_SESSION, data: event.data });
    posthog.register({ appSessionId: event.data.app.session?.id });
    return {
      ...event.data,
      app: {
        ...event.data.app,
        status: AppStatus.READY,
      },
    };
  }
};
